import React from 'react';
import Layout from '@/components/layout/Layout';
import Seo from '@/components/common/Seo';
import { registerTranslations } from '@/hooks/useTranslation';
import translations from './translations';
import ShopwareHero from '@/components/ShopwareLanding/ShopwareHero';
import ShopwareFeaturesList from '@/components/ShopwareLanding/ShopwareFeaturesList';
import ShopwareCompetence from '@/components/ShopwareLanding/ShopwareCompetence';
import ShopwareProcess from '@/components/ShopwareLanding/ShopwareProcess';
import ShopwareTestimonials from '@/components/ShopwareLanding/ShopwareTestimonials';
import ShopwareCTA from '@/components/ShopwareLanding/ShopwareCTA';
import ShopwareBanner from '@/components/ShopwareLanding/ShopwareBanner';

// Registriere seitenspezifische Übersetzungen
registerTranslations('shopwareLandingPage', translations);

const ShopwareLandingPage = () => {
  return (
    <>
      <Seo 
        title="Shopware Shop programmieren lassen | Professionelle Shopware Agentur" 
        description="Shop programmieren lassen von Experten ✓ Über 10 Jahre Shopware-Erfahrung ✓ B2B & B2C Shops ✓ Individuelle Entwicklung ✓ Jetzt kostenlos beraten lassen"
        canonical="/shopware-entwicklung"
      />
      <Layout>
        <main>
          <ShopwareBanner />
          <ShopwareHero />
          <ShopwareFeaturesList />
          <ShopwareCompetence />
          <ShopwareProcess />
          <ShopwareTestimonials />
          <ShopwareCTA />
        </main>
      </Layout>
    </>
  );
};

export default ShopwareLandingPage; 